import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { convertToPence, convertToPounds } from '@homamo/meadow-utils';

import Error from '../../common/ErrorMessage';
import Button, { ButtonGroup } from '../../common/Button';
import Form from '../../common/Form';
import CurrencyInput from '../../common/CurrencyInput';
import API, { handleApiError } from '../../../lib/api';

const validationSchema = Yup.object().shape({
  remainingBalance: Yup.string().required('You need to enter an amount'),
});

const AdjustBalanceForm = ({
  mortgageId,
  remainingBalance,
  successAction,
  cancelAction,
  isAdminMode,
}) => {
  const [displayError, setDisplayError] = React.useState();

  return (
    <>
      <Error error={displayError} />
      <Formik
        onSubmit={async (values, { setSubmitting }) => {
          await API.post(`mortgages/adjust-balance/${mortgageId}`, {
            remainingBalance: convertToPence(values.remainingBalance),
            adminMode: isAdminMode,
          })
            .then(() => {
              setSubmitting(false);
              toast.success('Balance adjusted');
              if (successAction) successAction();
            })
            .catch((error) => {
              handleApiError({ error, setDisplayError });
            })
            .finally(() => setSubmitting(false));
        }}
        initialValues={{
          remainingBalance: convertToPounds(remainingBalance),
        }}
        validationSchema={validationSchema}
        render={({ errors, isSubmitting }) => {
          return (
            <Form>
              <Error error={errors} />
              <Field
                label="Remaining Balance"
                id="remainingBalance"
                name="remainingBalance"
                placeholder="Enter an amount"
                component={CurrencyInput}
                isRequired
              />
              <ButtonGroup>
                <Button
                  label="Adjust remaining balance"
                  type="submit"
                  mode="primary"
                  loadingLabel="Reconciling"
                  isLoading={isSubmitting}
                />
                {cancelAction && (
                  <Button label="Cancel" onClick={cancelAction} />
                )}
              </ButtonGroup>
            </Form>
          );
        }}
      />
    </>
  );
};

AdjustBalanceForm.propTypes = {
  mortgageId: PropTypes.string.isRequired,
  remainingBalance: PropTypes.number.isRequired,
  successAction: PropTypes.func,
  cancelAction: PropTypes.func,
  isAdminMode: PropTypes.bool,
};

AdjustBalanceForm.defaultProps = {
  successAction: undefined,
  cancelAction: undefined,
  isAdminMode: false,
};

export default AdjustBalanceForm;
